/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import { debounce } from 'lodash';
import { TextField, InputAdornment } from '@mui/material/';
import SearchIcon from '@mui/icons-material/Search';
import { RestApiForm } from '../../tasks/types';

interface Props {
  form: RestApiForm;
  placeholder?: string;
  setGlobalFilter: (filter: string) => void;
  resetFilter: boolean
}

const GlobalFilter: React.FC<Props> = ({
  form: { system_type },
  setGlobalFilter,
  placeholder,
  resetFilter,
}) => {
  const [value, setValue] = React.useState('');

  const onChange = React.useCallback(
    debounce((val) => setGlobalFilter(val || undefined), 1000),
    [],
  );

  useEffect(() => {
    if (resetFilter) {
      setValue('');
    }
  }, [resetFilter]);

  const filterTypeMap = {
    basic_task: 'tasks',
    basic_issue: 'issues',
  };
  const holder = placeholder ?? `Search ${filterTypeMap[system_type] || 'records'}`;

  return (
    <TextField
      fullWidth
      type="search"
      variant="outlined"
      value={value || ''}
      onChange={(e) => {
        setValue(e.target.value);
        onChange(e.target.value);
      }}
      placeholder={holder}
      InputLabelProps={{
        shrink: true,
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
      size="small"
      onKeyPress={(e) => e.key === 'Enter' && e.preventDefault()}
    />
  );
};

export default GlobalFilter;
